import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-custom-fields-modal',
  templateUrl: './custom-fields-modal.component.html',
  styleUrls: ['./custom-fields-modal.component.scss']
})
export class CustomFieldsModalComponent implements OnInit {
  @Input() headers: any;
  @Input() selected: any;
  result = [];
  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.result = this.selected;
  }

  close() {
    this.activeModal.dismiss('dismiss');
  }

  valid() {
    this.activeModal.close(this.result);
  }

}
